export default __webpack_public_path__ + "static/media/IFD_logo.73fa2ed8.png";